export type LabelStatusType = { [key: string]: keyof typeof labelStatus }

export const labelStatus: Record<number, string> = {
  1: 'error',
  2: 'processing',
  3: 'success'
}

export const labelText: Record<number, string> = {
  1: 'task.high',
  2: 'task.medium',
  3: 'task.low'
}
